import { render } from "./login.vue?vue&type=template&id=05059366&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=05059366&lang=scss&scoped=true"

import exportComponent from "/var/www/toll-collector/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05059366"]])

export default __exports__